import { render, staticRenderFns } from "./activity_share_page.vue?vue&type=template&id=6b99ccac&scoped=true"
import script from "./activity_share_page.vue?vue&type=script&lang=js"
export * from "./activity_share_page.vue?vue&type=script&lang=js"
import style0 from "./activity_share_page.vue?vue&type=style&index=0&id=6b99ccac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b99ccac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b99ccac')) {
      api.createRecord('6b99ccac', component.options)
    } else {
      api.reload('6b99ccac', component.options)
    }
    module.hot.accept("./activity_share_page.vue?vue&type=template&id=6b99ccac&scoped=true", function () {
      api.rerender('6b99ccac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/group_buy/activity_share_page.vue"
export default component.exports